/**
 * Validates that the deployment environment is production
 */
export const environment = {
  production: true
};
